import { getCookie, hasCookie, setCookie } from 'cookies-next'
import type { IncomingMessage, ServerResponse } from 'http'
import type { NextApiRequestCookies } from 'next/dist/server/api-utils'
import { v4 } from 'uuid'

const RID_COOKIE = 'X-RID'
const ONE_YEAR_IN_SECONDS = 31536000

type NextServerRequest = IncomingMessage & { cookies: NextApiRequestCookies }

export const getRID = (req?: NextServerRequest, res?: ServerResponse): string => {
  if (hasCookie(RID_COOKIE, { req, res })) {
    const cookie = getCookie(RID_COOKIE, { req, res })
    if (typeof cookie === 'string' && cookie.length > 0) return cookie
  }

  const rid = v4()
  setCookie(RID_COOKIE, rid, { maxAge: ONE_YEAR_IN_SECONDS, req, res })
  return rid
}
